import type React from "react";

interface SectionHeaderProps {
	className?: string; // 容器附加样式
	lineColor?: string; // 线条颜色（hex 或 CSS 颜色值）
	lineHeightClassName?: string; // 线条高度类，例如 "h-0.5"
	showBar?: boolean; // 是否显示左侧粗条
	barColor?: string; // 粗条颜色
	barWidthClassName?: string; // 粗条宽度类，例如 "w-12"
	barHeightClassName?: string; // 粗条高度类，例如 "h-2"
	orientation?: "horizontal" | "vertical"; // 文字与线条的布局方向
	// 右侧缺口（小短缺口）设置
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
	className = "",
	lineColor = "#D3D3D3",
	lineHeightClassName = "h-[1px]",
	showBar = true,
	barColor = "#E5E5E5",
	barWidthClassName = "w-[120px]",
	barHeightClassName = "h-[4px]",
}) => {
	return (
		<div className={`w-full max-w-[500px] flex items-end ${className}`}>
			{showBar && (
				<div className={`${barWidthClassName} ${barHeightClassName}`} style={{ backgroundColor: barColor }} />
			)}
			<div className={`flex-1 ${lineHeightClassName}`} style={{ backgroundColor: lineColor }} />
		</div>
	);
};

export default SectionHeader;
